import { useMemo } from 'react';

export default function IndexSection() {
  const items = useMemo(() => [
    {
      id: 1,
      icon: 'ri-fire-line',
      label: '今日热瓜',
      desc: '本日最火爆的吃瓜视频合集',
      color: 'text-primary-500',
      bg: 'bg-primary-50',
    },
    {
      id: 2,
      icon: 'ri-live-line',
      label: '暗网直播',
      desc: '实时暗网吃瓜直播频道',
      color: 'text-accent-600',
      bg: 'bg-accent-50',
    },
    {
      id: 3,
      icon: 'ri-vidicon-line',
      label: '51吃瓜在线',
      desc: '51吃瓜在线视频精选',
      color: 'text-primary-500',
      bg: 'bg-primary-50',
    },
    {
      id: 4,
      icon: 'ri-movie-line',
      label: '51cg吃瓜',
      desc: '51cg吃瓜频道热门内容',
      color: 'text-accent-600',
      bg: 'bg-accent-50',
    },
    {
      id: 5,
      icon: 'ri-flashlight-line',
      label: '深夜爆料',
      desc: '夜间独家暗网吃瓜视频',
      color: 'text-primary-500',
      bg: 'bg-primary-50',
    },
    {
      id: 6,
      icon: 'ri-discuss-line',
      label: '吃瓜讨论',
      desc: '热门事件深度追踪讨论',
      color: 'text-accent-600',
      bg: 'bg-accent-50',
    },
    {
      id: 7,
      icon: 'ri-survey-line',
      label: '专题合集',
      desc: '按事件整理的全套吃瓜资源',
      color: 'text-primary-500',
      bg: 'bg-primary-50',
    },
  ], []);

  return (
    <section id="index" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900">
            吃瓜专题索引
          </h2>
          <p className="text-sm text-foreground-500 mt-3">快速找到你最感兴趣的吃瓜内容</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-7 gap-3 md:gap-4">
          {items.map((item) => (
            <a
              key={item.id}
              href="#topics"
              className={`${item.bg} rounded-xl p-4 md:p-5 text-center border border-background-200/60 hover:border-primary-300 transition-all duration-200 group cursor-pointer flex flex-col items-center`}
            >
              <span className={`w-10 h-10 md:w-12 md:h-12 rounded-xl ${item.color} flex items-center justify-center text-lg md:text-xl group-hover:scale-110 transition-transform`}>
                <i className={item.icon}></i>
              </span>
              <p className="text-sm font-semibold text-foreground-800 mt-3 whitespace-nowrap">{item.label}</p>
              <p className="text-xs text-foreground-500 mt-1 leading-tight">{item.desc}</p>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}